import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import './static/css/App.css';
import './static/css/styles.css';
import './sass/App.scss';
import './static/css/vendor-styles.css';
import './static/flaticon/flaticon.css';
import React, { Component } from 'react';
import Alert from 'react-s-alert';
import AlertContentTemplate from './components/alertComponent';
import { connect } from 'react-redux';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Header from './containers/header.js';
import IdleTimer from 'react-idle-timer';
import { logoutAction } from './modules/logins/actions/LoginActions';
import { ParseEDI835FromClearingHouse } from './modules/Billing/components/manageClaims/actions/ManageClaimActions';
import { CheckUserPasswordStatus } from './modules/Dashboards/actions/StaffDashboardActions';
import { CheckClientPasswordStatus } from './modules/PatientPortal/containers/dashboard/actions/ClientDashboardActions';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import PatientPortalHeader from './containers/patient-portal-header';
import SuperadminHeader from './containers/super-admin-header';
import SidebarMenuRouters from './routers/routers.js';
import history from '../src/history';


const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#09A7DC',
    accent1Color: '#40c741',
  },
});

// window.addEventListener("beforeunload", function (e) {
//   var confirmationMessage = 'It looks like you have been editing something.';
//   confirmationMessage += 'If you leave before saving, your changes will be lost.';

//   this.props.logoutAction();
//   (e || window.event).returnValue = confirmationMessage; //Gecko + IE

//   return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
// });

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      timeout: 1000 * 60 * 30, // 1000 * 60 * 10, // 10 mins & 1000 * 60 * 15, // 15 mins & 1000 * 60 * 30, // 30 mins
    };
    this._onActive = this._onActive.bind(this);
    this._onIdle = this._onIdle.bind(this);
    // this.onUnload = this.onUnload.bind(this);
  }

  // onUnload(event) { // the method that will be used for both add and remove event    
  //   //if (history.location.pathname !== '/login') {      
  //     this.props.logoutAction();
  //   //}
  //   //  event.returnValue = false;
  // }
  _onActive() { // do some action on active. Do not remove commented for further use.*
    // console.log('user activated: ');
  }

  _onIdle() { // on idle timeout - remove localstorage session and redirect to login page.
    if (history.location.pathname !== '/login') {
      this.props.logoutAction();
    }
  }

  componentDidMount() {
    //window.addEventListener("beforeunload", this.onUnload); 
    setTimeout(function () {        
    if(this.props.loginUserInfo && this.props.loginUserInfo.users3 && this.props.loginUserInfo.users3.userRoles.roleName.toUpperCase() === 'CLIENT')
    {
        this.props.CheckClientPasswordStatus();      // For 24 hours        
    }    
    else
    {
      //Calling For EDI 835 Parsing 
      //setTimeout(function () { this.props.ParseEDI835FromClearingHouse(); }.bind(this), 86400000);      // For 24 hours              
      this.props.CheckUserPasswordStatus();      // For 24 hours  
    }}.bind(this), 86400000); 
  }

  render() {
    return (
      <div className="hgt100">
        <IdleTimer
          ref="idleTimer"
          element={document}
          activeAction={this._onActive}
          idleAction={this._onIdle}
          timeout={this.state.timeout}
          format="MM-DD-YYYY HH:MM:ss.SSS">
          <MuiThemeProvider muiTheme={muiTheme}>
            <div className="hg100">
              {this.props.loginUserInfo ?
                <span>
                  {this.props.loginUserInfo.users3 ? this.props.loginUserInfo.users3.userRoles.roleName === 'Client' ?
                    <PatientPortalHeader />
                    : <Header />
                    :
                    this.props.loginUserInfo.roleName.toUpperCase() === 'SUPERADMIN' ?
                      <SuperadminHeader /> : this.props.loginUserInfo.roleName.toUpperCase() === 'SUPERUSER' ?
                      <SuperadminHeader /> : ''
                  }
                </span>
                :
                ''}
              <SidebarMenuRouters />
            </div>
          </MuiThemeProvider>
        </IdleTimer>
        <Alert contentTemplate={AlertContentTemplate} stack={{ limit: 3 }} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    access_token: state.login.access_token,
    loginUserInfo: state.login.loginUserInfo,
  };
}

export default connect(mapStateToProps, { logoutAction, ParseEDI835FromClearingHouse, CheckUserPasswordStatus, CheckClientPasswordStatus })(App);



// WEBPACK FOOTER //
// ./src/App.js